module.exports = __webpack_public_path__ + "static/our-purpose-8a276ff8cf93c2036900fba680661d03.svg";